import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import DocumentTitle from 'react-document-title'
import { connect } from 'react-redux'
import GoogleLogin from 'react-google-login'
import AppleLogin from 'react-apple-login'
import { login, externalLogin } from '../../actions/session'
import LoginForm from '../../components/forms/LoginForm'
// FIXME eslint must be fixed
/* eslint-disable */
import Icon from '../../components/misc/Icons'
import getErrorMessageForRequest from '../../utils/getErrorMessageForRequest'
/* eslint-enable */

const responseGoogle = (/* response */) => {}

class SignUpWithGoogleBtn extends React.Component {
  render() {
    return (
      <GoogleLogin
        clientId={process.env.REACT_APP_PLICKERS_GOOGLE_AUTH_CLIENT_ID}
        onSuccess={this.props.googleLogin}
        onFailure={responseGoogle}
        className="signin-continueWithGoogleBtn signin-continueWithGoogleBtn--default"
      >
        <div className="signin-continueWithGoogleBtn-centerContent">
          <div className="signin-continueWithGoogleBtn-centerContent-icon">
            <Icon name="googleLogoSignInColor" />
            <Icon name="googleLogoSignInGray" />
          </div>
          <div className="signin-continueWithGoogleBtn-centerContent-label">
            Continue with Google
          </div>
        </div>
      </GoogleLogin>
    )
  }
}

class SignInWithAppleBtn extends React.Component {
  render() {
    return (
      <button
        onClick={this.props.appleLogin}
        className="signin-signInWithAppleBtn"
      >
        <div className="signin-signInWithAppleBtn-centerContent">
          <div className="signin-signInWithAppleBtn-centerContent-icon">
            <Icon name="appleSignInLogo" />
          </div>
          <div className="signin-signInWithAppleBtn-centerContent-label">
            Sign in with Apple
          </div>
        </div>
      </button>
    )
  }
}

class Login extends Component {
  constructor(props) {
    super(props)
    this.goToSignup = this.goToSignup.bind(this)
    this.googleLogin = this.googleLogin.bind(this)
    this.handleLogin = this.handleLogin.bind(this)
    this.goToForgotPassword = this.goToForgotPassword.bind(this)
    this.appleCallback = this.appleCallback.bind(this)
    this.state = {
      errorMessage: null,
      submitLoading: false,
    }
  }

  handleLogin(data) {
    this.setState({ submitLoading: true, errorMessage: null })
    this.props.login(data)
      .then(() => {
        if (window.analytics) {
          window.analytics.track('Login Success', {})
        }
      })
      .catch((error) => {
        this.setState({ submitLoading: false })
        const errorMessage = getErrorMessageForRequest({
          requestName: 'login',
          response: error.response,
          data: { email: data.email },
        })
        this.setState({ errorMessage })
        if (window.analytics) {
          let status
          if (error.response) {
            status = error.response.status
          }
          window.analytics.track('Login Failed', {
            error,
            response: error.response,
            status,
            email: data.email,
          })
        }
      })
  }

  appleCallback(data) {
    if (data.authorization) {
      const token = data.authorization.id_token
      const requestData = {
        type: 'apple',
        idToken: token,
        firstName: '-',
        lastName: '-',
      }
      if (data.user) {
        requestData.firstName = data.user.name.firstName
        requestData.lastName = data.user.name.lastName
      }
      this.props.externalLogin(requestData).then(() => {})
    }
  }

  googleLogin(googleUser) {
    this.setState({ submitLoading: true })
    const requestData = {
      type: 'google',
      idToken: googleUser.tokenId,
    }
    this.props.externalLogin(requestData).then(() => {
      const authInstance = window.gapi.auth2.getAuthInstance()
      authInstance.disconnect()
    })
  }

  goToSignup() {
    this.props.history.push('signup')
  }

  goToForgotPassword() {
    this.props.history.push('forgot-password')
  }

  render() {
    return (
      <DocumentTitle title="Sign in - Plickers">
        <div className="signin marketing notranslate">

          <div className="signin-centerBlock">
            <div className="signin-centerBlock--top" />
            <div className="signin-centerBlock--middle">
              <div className="signin-centerBlock-logo">
                <Icon name="logo-full" />
              </div>
              <div className="signin-centerBlock-spacer" />
              <div className="signin-centerBlock-divider">
                <div className="signin-centerBlock-divider-line" />
                <div className="signin-centerBlock-divider-label">
                  or sign in with email and password
                </div>
                <div className="signin-centerBlock-divider-line" />
              </div>

              <LoginForm
                onSubmit={this.handleLogin}
                loginError={this.state.errorMessage}
                submitLoading={this.state.submitLoading}
              />

              <div className="signin-thirdPartyBtnContainer">
                <SignUpWithGoogleBtn googleLogin={this.googleLogin} />
                <AppleLogin
                  clientId={process.env.REACT_APP_SIGN_IN_WITH_APPLE_CLIENT_ID}
                  redirectURI={process.env.REACT_APP_SIGN_IN_WITH_APPLE_REDIRECT_URI}
                  usePopup
                  callback={this.appleCallback}
                  scope="email name"
                  responseType="query"
                  render={(props) => (<SignInWithAppleBtn appleLogin={props.onClick} />)}
                />
              </div>

              <div className="signin-centerBlock-forgotPasswordContainer">
                <div className="signin-centerBlock-forgotPassword" onClick={this.goToForgotPassword}>
                  Forgot Password?
                </div>
              </div>

            </div>

            <div className="signin-centerBlock--bottom">
              <div className="signin-centerBlock-goToCreateAccount" onClick={this.goToSignup}>
                Don’t have an account? Sign up for free
              </div>
            </div>

          </div>
        </div>
      </DocumentTitle>
    )
  }
}

export default withRouter(connect(
  (/* state */) => ({}),
  { login, externalLogin },
)(Login))
